<script>
export default {
  data() {
    return {
      dragOptions: {
        animation: 200,
        group: this.question.id,
        disabled: false,
        ghostClass: "ghost",
      },
      drag: false,
      drag_question_id: "",
      drag_optionList: [],
    };
  },
  methods: {
    drag_start(e) {
      this.drag = true;
    },
    drag_end(e) {
      this.drag = false;
      //todo 调用接口
      //       groupId	分组id
      // id	string 题目ID
      // orders	排序
      let optionRanks = [];
      let orders = 0;
      console.log(this.question)
      if(this.question.ifGrouping){
        for(let group of this.question.groupingOptionList){
          let group_id = group.id;
          if(group_id == 0){
            group_id="";
          }
          for(let option of group.questionsOptionVOS){
            optionRanks.push({
              id:option.id,
              groupId:group_id,
              orders:orders++
            })
          }
        }
      }else{
        for(let option of this.question.optionList){
          optionRanks.push({
              id:option.id,
              groupId:"",
              orders:orders++
            })
        }
      }
      console.log({optionRanks})
      this.$api.optionRank(optionRanks).then(res=>{
        console.log(res);
      }).catch(error=>{
        console.error(error)
      })

    },
    drag_change(e) {
      //插入了一个不知道是啥的玩意，删除它
      if (e.added) {
        let { element, newIndex } = e.added;
        if (element.questionsId == this.question.id) {
          this.questionlist.splice(newIndex, 1);
        }
      }
    }
  },
};
</script>
